export enum SystemEvent {
  ResourceFileUploaded,
  UsersAddedToTheProgram,
  ExistedPendingActivityCompleted,
  PendingActivityRemoved,
  PendingActivityEdited,
  PendingActivityCompleted,
  PendingActivityCanceled,
  PendingActivityCanceledByAnother,
  NewCompletedActivityEdited,
  NewCompletedActivityCanceled,
  CompletedActivityEdited,
  CompletedActivityRemoved,
  CompletedActivityReturned,
  CompletedActivityAdded,
  CompletedActivityUpdated,
  ActivityProcessing,
  ActivityProcessingFailed,
  RouteNavigatedBack,
  ChartDataChanged,
  PendingTaskAdded,
  TaskAdded,
  TaskEdited,
  PolicyAdded,
  PolicyEdited,
  SettingItemAdded,
  SettingItemsAdded,
  FormInstanceHeaderChanged,
  DropUpOpened,
  DropUpClosed,
  HighFiveCreated,
  TrainingCoordinatorsAdded,
  ExportCallTypesFromCad,
  UpdatedDataForHeader,
  GainsightScriptLoaded,
  EidSdkScriptLoaded,
  TopNavScriptLoaded
}
